import { Types } from "../../constants/index.js";
import FirmwareApplication from "../builders/FirmwareApplication.js";
export default FirmwareApplication({
  objectType: Types.device,
  attrName: 'reportedFirmwareApplication',
  idAttrName: 'reportedFirmwareApplicationId',
  displayName: 'Reported Firmware Application'
});